import { Icon, notification } from 'antd';
import React from 'react'
/**
*Mostrar notificaciones de advertencia o estatus ok al usuario
* 
*@param: mensaje: Mensaje que se mostrará en el cuerpo de la notificación 
*@param: titulo: Sting para determinar el tipo de notificación que se abrirá
*@param: segundos: Determina el número de segundos que se queda abierta la notificación
* Si se resibe false, se mostrará mensaje de advertencia. 
*@return: nada
*/
export const openNotification = (mensaje, titulo, segundos = 5) => {
    const style = {
        whiteSpace: 'pre-wrap',
        wordWrap: 'break-word' 
    }
    notification.config({
        placement: 'bottomRight',
        duration: segundos,
    })
    if (titulo === 'Éxito') {
        notification.open({
            message: mensaje,
            style: style,
            icon: <Icon type="check-circle" style={{ color: '#008F39' }} />,
        });
    }
    if (titulo === 'Aviso') {
        notification.warning({
            message: mensaje,
            style: style,
            icon: <Icon type="exclamation-circle" style={{ color: 'rgb(253, 135, 0)' }} />,
        });
    }
    if (titulo === 'Error') {
        notification.error({
            message: mensaje ?? 'Se han presentado problemas de comunicación en el sistema, favor de reportarlo.',
            style: style,
            icon: <Icon type="close-circle" style={{ color: 'rgb(255, 0, 0)' }} />,
        });
    }
}